import { getUploadConfig } from './modules/upload-config';
import UploadField from './modules/upload-field';

const initializedFields = new Set();

const initUploadFields = () => {
	const { config, i18n, rest } = getUploadConfig();

	Object.keys(config).forEach((htmlId) => {
		if (initializedFields.has(htmlId)) {
			return;
		}

		const field = new UploadField({
			htmlId,
			config: config[htmlId],
			i18n,
			rest,
		});

		field.init();
		initializedFields.add(htmlId);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initUploadFields);
} else {
	initUploadFields();
}
